// extracted by mini-css-extract-plugin
var _1 = "ContextMenu__ContextMenu___duR6n";
var _2 = "ContextMenu__item___tDBWx";
var _3 = "ContextMenu__wiggle___yAwsu";
export { _1 as "ContextMenu", _2 as "item", _3 as "wiggle" }
